import { render } from "./MySentGpsDeviceTransferRequest.vue?vue&type=template&id=4a25037e&scoped=true"
import script from "./MySentGpsDeviceTransferRequest.vue?vue&type=script&lang=js"
export * from "./MySentGpsDeviceTransferRequest.vue?vue&type=script&lang=js"

import "./MySentGpsDeviceTransferRequest.vue?vue&type=style&index=0&id=4a25037e&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a25037e"]])

export default __exports__